const enerjiDepolama = [
  {
    "title": "TommaTech Hightech Power Serisi 3kWh Lityum Batarya",
    "image": "https://cw-enerji.com/images/kategory_grup/153_tommatech-hightech-power-serisi-3kwh-lityum-batarya.webp",
    "text": "Uzaktan İzleme Seçenekleri\nHızlı & Kolay Kurulum\nArttırılabilir Enerji Kapasitesi\nTommaTech Hibrit Serisi ile Kesintisiz ve Kompakt bir Enerji Sistemi\n%90 Deşarj Derinliği\nYeni Nesil LFP Teknolojisi ile Verimli ve Güvenli Enerji Konsepti\n10 Yıl Garanti",
    "variants": [
      {
        "wp": "3 kWh",
        "link": "https://cw-enerji.com/tr/urun/tommatech-hightech-power-3kwh-lityum-batarya-351.html"
      }
    ]
  },
  {
    "title": "TommaTech 3kWh Lityum Batarya+Depolama Yönetim Sistemi",
    "image": "https://cw-enerji.com/images/kategory_grup/154_tommatech-3kwh-lityum-bataryadepolama-yonetim-sistemi.webp",
    "text": "Uzaktan İzleme Seçenekleri\nHızlı & Kolay Kurulum\nArttırılabilir Enerji Kapasitesi\nTommaTech Hibrit Serisi ile Kesintisiz ve Kompakt bir Enerji Sistemi\n%90 Deşarj Derinliği\nYeni Nesil LFP Teknolojisi ile Verimli ve Güvenli Enerji Konsepti\n10 Yıl Garanti",
    "variants": [
      {
        "wp": "3 kWh",
        "link": "https://cw-enerji.com/tr/urun/tommatech-3kwh-lityum-bataryadepolama-yonetim-sistemi-352.html"
      }
    ]
  },
  {
    "title": "TommaTech Hightech Power Serisi 5.8 kWh Lityum Bataryalar",
    "image": "https://cw-enerji.com/images/kategory_grup/124_tommatech-hightech-power-serisi-58-kwh-lityum-bataryalar.webp",
    "text": "Uzaktan İzleme Seçenekleri\nHızlı & Kolay Kurulum\nArttırılabilir Enerji Kapasitesi\nTommaTech Hibrit Serisi ile Kesintisiz ve Kompakt bir Enerji Sistemi\n%90 Deşarj Derinliği\nYeni Nesil LFP Teknolojisi ile Verimli ve Güvenli Enerji Konsepti\n10 Yıl Garanti",
    "variants": [
      {
        "wp": "5.8 kWh",
        "link": "https://cw-enerji.com/tr/urun/tommatech-hightech-power-boosterpack-5-8kwh-lityum-batarya-354.html"
      },
      {
        "wp": "5.8 kWh",
        "link": "https://cw-enerji.com/tr/urun/tommatech-hightech-power-generalpack-5-8kwh-lityum-batarya-353.html"
      }
    ]
  },
  {
    "title": "TommaTech 3kWh Lityum Batarya Aksesuar Seti",
    "image": "https://cw-enerji.com/images/product/1453_tommatech-3kwh-lityum-aksesuar-seti_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Hightech Power Paralel Bağlantı Kutusu",
    "image": "https://cw-enerji.com/images/product/1456_tommatech-hightech-power-paralel-baglanti-kutusu_0.png",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Serisi 12.8V 204AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1657_tommatech-modular-serisi-128v-204ah-g2-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Serisi 12.8V 102AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1653_tommatech-moduler-serisi-128v-102ah-g2-lfp-lityum-batarya_0.webp",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Serisi 25.6V 102AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1654_tommatech-modular-serisi-256v-102ah-g2-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Serisi 25.6V 204AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1658_tommatech-modular-serisi-256v-204ah-g2-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Serisi 51.2V 102AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1659_tommatech-modular-serisi-512v-102ah-g2-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Rack Serisi 51.2V 102AH G2 LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1660_tommatech-rack-serisi-512v-102ah-g2-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler V Serisi 51.2V 280Ah LFP Lityum Batarya",
    "image": "https://cw-enerji.com/images/product/1858_tommatech-moduler-v-serisi-512v-208ah-lfp-lityum-batarya_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nYenilikçi Tasarım ve Isıya Dayanıklı Yapı\nArtırılabilir Kapasite\nHaberleşme\nIP20-IP65 Koruma Sınıfı\nSürdürülebilir Enerji\n5 Yıl Ürün Garantisi",
    "variants": []
  },
  {
    "title": "TommaTech Modüler Yüksek Voltajlı Enerji Depolama Sistemi",
    "image": "https://cw-enerji.com/images/product/1876_tommatech-moduler-yuksek-voltajli-enerji-depolama-sistemi_0.webp",
    "text": "Yüksek Voltajlı\nModüler Yapı\nLFP Hücre Teknolojisi\nAkıllı Güvenlik Özelliği\nGenişletilebilir Kapasite\nYüksek Verimli",
    "variants": []
  },
  {
    "title": "TommaTech Modular Series 25.6-51.2V LFP Lityum Batarya Metal Alt Taban",
    "image": "https://cw-enerji.com/images/product/1384_tommatech-modular-series-256-512v-lfp-lityum-batarya-metal-alt-taban_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "CW Storage Konteyner Güç ve Enerji Depolama Sistemleri",
    "image": "https://cw-enerji.com/images/product/1562_cw-storage-konteyner-guc-ve-enerji-depolama-sistemleri_0.webp",
    "text": "Gelişmiş Batarya Yönetim Sistemi\n Güvenlik ve Koruma Bileşenleri\n Sıvı Soğutma Teknolojisi\n 6000 Üzeri Döngü Sayısı(0.5C)\n On-Grid, Off-Grid veya Hibrit Çalışma Senaryosu\n Güvenlikli Lityum Demir Fosfat Pil Mimarisi\n İleri Düzey Termal Yönetim Sistemi\n Kolay ve Hızlı Kurulum",
    "variants": []
  },
  {
    "title": "TommaTech Kabin Tipi 60kWh Güç ve Enerji Depolama",
    "image": "https://cw-enerji.com/images/product/1599_tommatech-kabin-tipi-60kwh-guc-ve-enerji-depolama_0.jpg",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nIsıya Dayanıklı Yapı\nIP65 Koruma Sınıfı\nDayanıklı Metal Kasa Tasarımı",
    "variants": []
  },
  {
    "title": "TommaTech Kabin Tipi 60kWh-50kW Güç ve Enerji Depolama",
    "image": "https://cw-enerji.com/images/product/1598_tommatech-kabin-tipi-60kwh-50kw-guc-ve-enerji-depolama_0.webp",
    "text": "Yüksek Performans\nAktif Akıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nIsıya Dayanıklı Yapı\nIP65 Koruma Sınıfı\nDayanıklı Metal Kasa Tasarımı",
    "variants": []
  },
  {
    "title": "TommaTech İnverterli̇ Kabi̇n Depolama Si̇stemi̇",
    "image": "https://cw-enerji.com/images/product/1561_tommatech-inverterli-kabin-depolama-sistemi_0.jpg",
    "text": "Yüksek Performans\nAkıllı Yönetim Sistemi\nUzun Kullanım Ömrü\nIsıya Dayanıklı Yapı\nIP65 Koruma Sınıfı\nDayanıklı Metal Kasa\nKolay Kurulum Ve Kullanım",
    "variants": []
  },
  {
    "title": "TommaTech All Under One Series 3.6K-200Ah",
    "image": "https://cw-enerji.com/images/product/1565_tommatech-all-under-one-series-36k-200ah_0.webp",
    "text": "Sürdürülebilir Enerji\nKesintisiz Güç\nVerimli Enerji Yönetimi\nKolay Entegrasyon\nÇevre Dostu",
    "variants": []
  },
  {
    "title": "TommaTech All Under One Series 7.2K-200Ah",
    "image": "https://cw-enerji.com/images/product/1566_tommatech-all-under-one-series-72k-200ah_0.jpg",
    "text": "Sürdürülebilir Enerji\nKesintisiz Güç\nVerimli Enerji Yönetimi\nKolay Entegrasyon\nÇevre Dostu",
    "variants": []
  },
  {
    "title": "TommaTech All Under One Series 11K-300Ah",
    "image": "https://cw-enerji.com/images/product/1567_tommatech-all-under-one-series-11k-300ah_0.jpg",
    "text": "Sürdürülebilir Enerji\nKesintisiz Güç\nVerimli Enerji Yönetimi\nKolay Entegrasyon\nÇevre Dostu",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 80V-200A",
    "image": "https://cw-enerji.com/images/product/1807_tommatech-batarya-sarj-unitesi-duvar-tipi-80v-200a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 80V-100A",
    "image": "https://cw-enerji.com/images/product/1806_tommatech-batarya-sarj-unitesi-duvar-tipi-80v-100a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 72V-80A",
    "image": "https://cw-enerji.com/images/product/1805_tommatech-batarya-sarj-unitesi-duvar-tipi-72v-80a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 48V-150A",
    "image": "https://cw-enerji.com/images/product/1804_tommatech-batarya-sarj-unitesi-duvar-tipi-48v-150a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 48V-100A",
    "image": "https://cw-enerji.com/images/product/1605_tommatech-batarya-sarj-unitesi-duvar-tipi-48v-100a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Duvar Tipi 24V-100A",
    "image": "https://cw-enerji.com/images/product/1803_tommatech-batarya-sarj-unitesi-duvar-tipi-24v-100a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Entegre 48V-30A",
    "image": "https://cw-enerji.com/images/product/1604_tommatech-batarya-sarj-unitesi-entegre-48v-30a_0.jpg",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP65 Su Geçirmez",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Entegre 24V-50A",
    "image": "https://cw-enerji.com/images/product/1808_tommatech-batarya-sarj-unitesi-entegre-24v-50a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP65 Su Geçirmez",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Entegre 24V-30A",
    "image": "https://cw-enerji.com/images/product/1603_tommatech-batarya-sarj-unitesi-entegre-24v-30a_0.jpg",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP65 Su Geçirmez",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Mobil 72V-80A",
    "image": "https://cw-enerji.com/images/product/1809_tommatech-batarya-sarj-unitesi-mobil-72v-80a_0.webp",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Mobil 48V-100A",
    "image": "https://cw-enerji.com/images/product/1606_tommatech-batarya-sarj-unitesi-mobil-48v-100a_0.jpg",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech Batarya Şarj Ünitesi Mobil 24V-100A",
    "image": "https://cw-enerji.com/images/product/1607_tommatech-batarya-sarj-unitesi-mobil-24v-100a_0.jpg",
    "text": "PFC≥0.98\nAşırı gerilim koruması\nAşırı sıcaklık koruması\nKısa devre koruması\nIP20 Koruma Sınıfı",
    "variants": []
  },
  {
    "title": "TommaTech LiFePO4 Modüler Lityum Batarya Askı Aparatı",
    "image": "https://cw-enerji.com/images/product/941_tommatech-lifepo4-moduler-lityum-batarya-aski-aparati_0.jpg",
    "text": "",
    "variants": []
  }
];

export default enerjiDepolama;
